var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top",on:{"click":_vm.top}},[_vm._t("default",[_c('i',{staticClass:"iconfont iconzhiding1"}),(_vm.title)?_c('span',{staticClass:"icon-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }